

import templateUserPostListPage from '@/app-template/lib/pages/UserPostListPage.vue';

export default {
  name: "UserPostListPage",
  components: { templateUserPostListPage },
};
